module.exports = __webpack_public_path__ + "media/images/sp/top/google_review-61b1216c91504feb7bf8358898c7cf5c.webp";